import { render, staticRenderFns } from "./artistDetail.vue?vue&type=template&id=9a8a182c"
import script from "./artistDetail.vue?vue&type=script&lang=js"
export * from "./artistDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports